<template>
  <div class="container">
    <div class="content-i">
      <div class="content-box">
          <div class="row justify-content-center">
            <div class="col" >
              <div class="element-wrapper">
              
                <h3 class="element-header" ref="cadastroSinsaude">
                  Cadastro Cartão Dr.Achei Card
                </h3>
                <div class="element-box">
                  <form autocomplete="off">
                      <div class="steps-w">
                        <div class="step-triggers">
                            <a class="step-trigger active" href="#stepContent1">Dados do Titular</a>
                            <a class="step-trigger" href="#stepContent2">Endereço</a>
                            <a v-show="!isSeguroInternacao" class="step-trigger" href="#stepContent3">Dependentes</a>
                        </div>
                        <div class="step-contents">
                            <div class="step-content active" id="stepContent1">
                              <form @submit.prevent="next('stepContent1', 'stepContent2')" data-vv-scope="stepContent1">
                                <div class="form-row">
                                  <div class="form-group col-md-6" :class="{'has-danger': errors.has('stepContent1.name')}">
                                    <label for="username">Nome Completo</label>
                                      <input type="text" name="name" id="name"
                                        v-validate="'required'"
                                        v-model="payload.name"
                                        class="form-control">
                                    <div v-if="errors.has('stepContent1.name')" class="help-block form-text text-muted form-control-feedback">
                                        {{errors.first('stepContent1.name')}}
                                      </div>
                                  </div>
                                  <div class="form-group col-md-3" :class="{'has-danger': errors.has('stepContent1.cpf')}">
                                    <label for="username">CPF</label>
                                      <input type="tel" name="cpf" id="cpf"
                                        v-mask="'###.###.###-##'"
                                        v-validate="'required|cpf'"
                                        v-model="payload.cpf"
                                        class="form-control">
                                      <div v-if="errors.has('stepContent1.cpf')" class="help-block form-text text-muted form-control-feedback">
                                        {{errors.first('stepContent1.cpf')}}
                                      </div>
                                  </div>
                                  <div class="form-group col-md-3">
                                    <div class="form-group" :class="{'has-danger': errors.has('stepContent1.dataNascimento')}">
                                      <label for="date">Data de Nascimento</label>
                                      <input type="tel" name="dataNascimento" id="dataNascimento"
                                        v-validate="'required|date_format:DD/MM/YYYY|dataNascimentoPlano'"
                                        v-model="payload.dataNascimento" v-mask="'##/##/####'"
                                        class="form-control" aria-describedby="helpId">
                                      <div v-if="errors.has('stepContent1.dataNascimento')" class="help-block form-text text-muted form-control-feedback">
                                        {{errors.first('stepContent1.dataNascimento')}}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div class="form-row">
                                  <div class="form-group col-md-3">
                                    <div class="form-group" :class="{'has-danger': errors.has('stepContent1.sexo')}">
                                      <label for="sexo">Sexo</label>
                                      <select name="sexo" class="form-control" id="sexo"
                                        v-validate="'required'"
                                        v-model="payload.sexo">
                                          <option :value="null">Selecione</option>
                                          <option value="M">Masculino</option>
                                          <option value="F">Feminino</option>
                                      </select>
                                      <div v-if="errors.has('stepContent1.sexo')" class="help-block form-text text-muted form-control-feedback">
                                        {{errors.first('stepContent1.sexo')}}
                                      </div>
                                    </div>
                                  </div>
                                  <div class="form-group col-md-6">
                                    <div class="form-group" :class="{'has-danger': errors.has('stepContent1.naturalidade')}">
                                      <label for="naturalidade">Naturalidade</label>
                                      <input type="text" name="naturalidade" id="naturalidade"
                                        v-validate="'required'"
                                        v-model="payload.naturalidade"
                                        class="form-control" aria-describedby="helpId">
                                      <div v-if="errors.has('stepContent1.naturalidade')" class="help-block form-text text-muted form-control-feedback">
                                        {{errors.first('stepContent1.naturalidade')}}
                                      </div>
                                    </div>
                                  </div>
                                  <div class="form-group col-md-2">
                                    <div class="form-group" :class="{'has-danger': errors.has('stepContent1.estado')}">
                                      <label for="estado">Estado</label>
                                      <select name="estado" class="form-control" id="estado"
                                        v-model="payload.estado"
                                        v-validate="'required'">
                                          <option :value="null">Selecione</option>
                                          <option v-for="uf in ufs" :key="uf"
                                            :value="uf" v-text="uf" />
                                      </select>
                                      <div v-if="errors.has('stepContent1.estado')" class="help-block form-text text-muted form-control-feedback">
                                        {{errors.first('stepContent1.estado')}}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <hr>
                                <div class="row">
                                  <div class="form-group col">
                                    <div class="form-group" :class="{'has-danger': errors.has('stepContent1.plano')}">
                                      <label for="plano">Selecione o Plano</label>
                                      <select name="plano" class="form-control" id="plano"
                                        @change="$validator.reset()"
                                        v-validate="'required'"
                                        v-model="payload.plano">
                                          <option :value="null">Selecione</option>
                                          <option 
                                            v-for="plano in planos" :key="plano._id"
                                              :value="plano">
                                              {{plano.name}} ({{plano.price | money}}/mês)
                                          </option>
                                      </select>
                                       <div v-if="errors.has('stepContent1.plano')" class="help-block form-text text-muted form-control-feedback">
                                        {{errors.first('stepContent1.plano')}}
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <div class="form-row">
                                  <div class="form-group col-md-6">
                                    <div class="form-group" :class="{'has-danger': errors.has('stepContent1.email')}">
                                      <label for="email">E-mail</label>
                                      <input type="email" name="email" id="email"
                                        v-model="payload.email"
                                        v-validate="'required|email'"
                                        class="form-control" aria-describedby="helpId">
                                      <div v-if="errors.has('stepContent1.email')" class="help-block form-text text-muted form-control-feedback">
                                        {{errors.first('stepContent1.email')}}
                                      </div>
                                    </div>
                                  </div>
                                  <div class="form-group col-md-6">
                                    <div class="form-group" :class="{'has-danger': errors.has('stepContent1.celular')}">
                                      <label for="celular">Celular</label>
                                      <input type="tel" name="celular" id="celular"
                                        v-model="payload.telefoneCelular"
                                        v-validate="'required'"
                                        v-mask="['(##) ####-####', '(##) #####-####']"
                                        class="form-control" aria-describedby="helpId">
                                      <div v-if="errors.has('stepContent1.celular')" class="help-block form-text text-muted form-control-feedback">
                                        {{errors.first('stepContent1.celular')}}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              <div class="form-buttons-w text-right">
                              <button class="btn btn-primary step-trigger-btn" type="submit"> Continuar</button>
                              </div>
                            </form>
                          </div>
                          <div class="step-content" id="stepContent2" >
                                <form @submit.prevent="next('stepContent2', isSeguroInternacao ? 'CheckoutSinSaude' : 'stepContent3')" data-vv-scope="stepContent2">
                                  <div class="form-row">
                                    <div class="form-group col-md-4">
                                      <div class="form-group" :class="{'has-danger': errors.has('stepContent2.cep')}">
                                        <label for="celular">CEP</label>
                                        <input autofocus type="tel" name="cep" id="cep"
                                          @keyup="buscaCEP()"
                                          v-model="payload.cep"
                                          v-validate="'required'"
                                          v-mask="'#####-###'"
                                          class="form-control" aria-describedby="helpId">
                                        <div v-if="errors.has('stepContent2.cep')" class="help-block form-text text-muted form-control-feedback">
                                          {{errors.first('stepContent2.cep')}}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="form-row">
                                    <div class="form-group col-md-9">
                                      <div class="form-group" :class="{'has-danger': errors.has('stepContent2.endereco')}">
                                        <label for="endereco">Endereço</label>
                                        <input type="text" name="endereco" id="endereco"
                                          v-model="payload.endereco"
                                          v-validate="'required'"
                                          class="form-control" aria-describedby="helpId">
                                        <div v-if="errors.has('stepContent2.endereco')" class="help-block form-text text-muted form-control-feedback">
                                          {{errors.first('stepContent2.endereco')}}
                                        </div>
                                      </div>
                                    </div>
                                    <div class="form-group col-md-3">
                                      <div class="form-group" :class="{'has-danger': errors.has('stepContent2.nrEndereco')}">
                                        <label for="celular">Número</label>
                                        <input type="tel" name="nrEndereco" id="nrEndereco"
                                          v-model="payload.nrEndereco"
                                          v-validate="'required'"
                                          class="form-control" aria-describedby="helpId">
                                        <div v-if="errors.has('stepContent2.nrEndereco')" class="help-block form-text text-muted form-control-feedback">
                                          {{errors.first('stepContent2.nrEndereco')}}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="form-row">
                                    <div class="form-group col-md-4">
                                      <div class="form-group" :class="{'has-danger': errors.has('stepContent2.complemento')}">
                                        <label for="complemento">Complemento</label>
                                        <input type="text" name="complemento" id="complemento"
                                          v-model="payload.complemento"
                                          class="form-control" aria-describedby="helpId">
                                        <div v-if="errors.has('stepContent2.complemento')" class="help-block form-text text-muted form-control-feedback">
                                          {{errors.first('stepContent2.complemento')}}
                                        </div>
                                      </div>
                                    </div>
                                    <div class="form-group col-md-4">
                                      <div class="form-group" :class="{'has-danger': errors.has('stepContent2.bairro')}">
                                        <label for="bairro">Bairro</label>
                                        <input type="text" name="bairro" id="bairro"
                                          v-model="payload.bairro"
                                          v-validate="'required'"
                                          class="form-control" aria-describedby="helpId">
                                        <div v-if="errors.has('stepContent2.bairro')" class="help-block form-text text-muted form-control-feedback">
                                          {{errors.first('stepContent2.bairro')}}
                                        </div>
                                      </div>
                                    </div>
                                    
                                  </div>
                                  <div class="form-row">
                                    <div class="form-group col-md-6">
                                      <div class="form-group" :class="{'has-danger': errors.has('stepContent2.cidade')}">
                                        <label for="cidade">Cidade</label>
                                        <input type="text" name="cidade" id="cidade"
                                          v-model="payload.cidade"
                                          v-validate="'required'"
                                          class="form-control" aria-describedby="helpId">
                                        <div v-if="errors.has('stepContent2.cidade')" class="help-block form-text text-muted form-control-feedback">
                                          {{errors.first('stepContent2.cidade')}}
                                        </div>
                                      </div>
                                    </div>
                                    <div class="form-group col-md-2">
                                      <div class="form-group" :class="{'has-danger': errors.has('stepContent2.ufEndereco')}">
                                        <label for="ufEndereco">UF</label>
                                        <select name="ufEndereco" class="form-control" id="ufEndereco"
                                            v-validate="'required'"
                                            v-model="payload.ufEndereco">
                                            <option :value="null">Selecione</option>
                                            <option v-for="uf in ufs" :key="uf"
                                              :value="uf" v-text="uf" />
                                        </select>
                                        <div v-if="errors.has('stepContent2.ufEndereco')" class="help-block form-text text-muted form-control-feedback">
                                          {{errors.first('stepContent2.ufEndereco')}}
                                        </div>
                                      </div>
                                    </div>
                                    
                                  </div>
                                  <div class="form-buttons-w text-right">
                                    <button class="btn btn-primary step-trigger-btn"> {{ isSeguroInternacao ? 'Ir para Pagamento' : 'Continuar'}}</button>
                                  </div>
                                </form>
                          </div>
                          <div class="step-content" id="stepContent3" >
                              <form @submit.prevent="next('setpContent3', 'CheckoutSinSaude')" data-vv-scope="stepContent3">
                                <div class="form-row">
                                  <div class="col text-right">
                                    <button @click="addDependente" name="" id="" class="btn btn-success" type="button"
                                      :disabled="payload.dependentes.length === sizeDependentes">
                                      <i class="fa fa-plus"></i>
                                      Adicionar
                                      <b>{{payload.dependentes.length}} de {{sizeDependentes}}</b>
                                    </button>
                                  </div>
                                </div>
                                <div class="form-row">
                                  <div class="col"
                                    v-for="(dependente, i) in payload.dependentes"
                                    :key="i">
                                    <h5>Dependente {{i + 1}}</h5>
                                    <div class="form-group" :class="{'has-danger': errors.has(`stepContent3.dependenteNome${i}`)}">
                                      <label for=""> Nome Completo</label>
                                          <input :name="`dependenteNome${i}`" :id="`dependenteNome${i}`"
                                                v-validate="'required'"
                                                v-model="dependente.name" type="text" class="form-control">
                                          <div v-if="errors.has(`stepContent3.dependenteNome${i}`)" class="help-block form-text text-muted form-control-feedback">
                                            {{errors.first(`stepContent3.dependenteNome${i}`)}}
                                          </div>
                                    </div>
                                    <div class="row">
                                      <div class="col-sm-6">
                                          <div class="form-group" :class="{'has-danger': errors.has(`stepContent3.dependenteDtNascimento${i}`)}">
                                            <label for=""> Data de Nascimento</label>
                                            <input :name="`dependenteDtNascimento${i}`" :id="`dependenteDtNascimento${i}`"
                                                    v-validate="'required|date_format:DD/MM/YYYY'"
                                                    v-mask="'##/##/####'"
                                                    v-model="dependente.dataNascimento" class="form-control" type="tel">
                                            <div v-if="errors.has(`stepContent3.dependenteDtNascimento${i}`)" class="help-block form-text text-muted form-control-feedback">
                                              {{errors.first(`stepContent3.dependenteDtNascimento${i}`)}}
                                            </div>
                                          </div>
                                      </div>
                                      <div class="col-sm-6">
                                          <div class="form-group" :class="{'has-danger': errors.has(`stepContent3.dependenteCPF${i}`)}">
                                            <label for="">CPF</label>
                                            <input :name="`dependenteCPF${i}`" :id="`dependenteCPF${i}`"
                                                    v-validate="'required'"
                                                    v-mask="'###.###.###-##'"
                                                    v-model="dependente.cpf" class="form-control" type="tel">
                                            <div v-if="errors.has(`stepContent3.dependenteCPF${i}`)" class="help-block form-text text-muted form-control-feedback">
                                              {{errors.first(`stepContent3.dependenteCPF${i}`)}}
                                            </div>
                                          </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                
                                <div class="form-buttons-w text-right">
                                  <button class="btn btn-primary">Ir para pagamento</button>
                                </div>
                              </form>
                          </div>
                      </div>
                      </div>
                  </form>
              </div>
              </div>
            </div>  
          </div>
      </div>
    </div>
  </div>
</template>
<script>
import * as http from 'axios'
import eventBus from '@/event-bus'
import { Validator } from 'vee-validate'
import utils from '@/utils'

export default {
  created () {
    eventBus.$on('loginSuccess', this.irParaPagamento)
    function calcAge (dateString) {
      const [dia, mes, ano] = dateString.split('/')
      var birthday = +new Date(ano, parseInt(mes) - 1, dia, 0, 0, 0, 0)
      return ~~((Date.now() - birthday) / (31557600000))
    }

    Validator.extend('dataNascimentoPlano', {
      getMessage: field => 'A idade para contratação desse plano deve ser entre 16 e 65 anos',
      validate: value => {
        if (this.isSeguroInternacao) {
          let age = calcAge(value)
          return !!(age >= 16 && age <= 65)
        }
        return true
      }
    })

    Validator.extend('cpf', {
      getMessage: field => 'CPF inválido',
      validate: value => {
        return !!utils.TestaCPF(value)
      }
    })
  },
  data () {
    return {
      ufs: [ 'AC', 'AL', 'AM', 'AP', 'BA', 'CE', 'DF', 'ES', 'GO', 'MA', 'MT', 'MS', 'MG', 'PA', 'PB', 'PR', 'PE', 'PI', 'RJ', 'RN', 'RO', 'RS', 'RR', 'SC', 'SE', 'SP', 'TO' ],
      planos: [],
      repeteSenha: null,
      sizeDependentes: 3,
      payload: {
        plano: null,
        email: null,
        dataNascimento: null,
        telefoneCelular: null,
        username: null,
        password: null,
        estado: null,
        naturalidade: null,
        sexo: null,
        cidade: null,
        ufEndereco: null,
        endereco: null,
        bairro: null,
        complemento: null,
        nrEndereco: null,
        cep: null,
        dependentes: []
      }
    }
  },
  mounted () {
    // #7. FORM STEPS FUNCTIONALITY
    // FORM STEP CLICK
    this.$nextTick(() => {
      window.jQuery('.step-trigger').on('click', function () {
        var prevTrigger = window.jQuery(this).prev('.step-trigger')
        if (prevTrigger.length && !prevTrigger.hasClass('active') && !prevTrigger.hasClass('complete')) return false
        var contentId = window.jQuery(this).attr('href')
        window.jQuery(this).closest('.step-triggers').find('.step-trigger').removeClass('active')
        window.jQuery(this).prev('.step-trigger').addClass('complete')
        window.jQuery(this).addClass('active')
        window.jQuery('.step-content').removeClass('active')
        window.jQuery('.step-content' + contentId).addClass('active')
        return false
      })
    })
    // END STEPS FUNCTIONALITY

    console.log('Scroll me test')
    this.scrollMeTo('cadastroSinsaude')

    const qPlano = this.$route.query.plano
    http.get('/planos?drachei=true&publicado=true&order=price')
      .then(response => {
        this.planos = response.data
        this.payload.plano = this.planos.find(plano => plano.name.indexOf(qPlano) > -1)
      })

    if (this.user) {
      http.get(`/usuario/${this.user.id}`)
        .then(response => {
          let usr = response.data
          this.payload.name = usr.name
          this.payload.cpf = usr.cpf
          this.payload.email = usr.email
          this.payload.telefoneCelular = usr.telefoneCelular
        })
    }
    if (window.localStorage.getItem('cartaoCompra')) {
      window.localStorage.removeItem('cartaoCompra')
    }
  },
  watch: {
    'user' (newVal, oldVal) {
      if (newVal) {
        http.get(`/usuario/${newVal.id}`)
          .then(response => {
            let usr = response.data
            this.payload.name = usr.name
            this.payload.cpf = usr.cpf
            this.payload.email = usr.email
            this.payload.telefoneCelular = usr.telefoneCelular
          })
      }
    }
  },
  computed: {
    user () {
      return this.$store.getters.user
    },
    isSeguroInternacao () {
      return this.payload.plano && this.payload.plano.name === 'SEGURO INTERNAÇÃO DR ACHEI'
    }
  },
  methods: {
    next (from, to) {
      this.$validator.validateAll(from.replace('#', ''))
        .then(result => {
          if (result) {
            if (to === 'CheckoutSinSaude') {
              this.salvar()
            }
            window.jQuery('.step-trigger[href="#' + to + '"]').click()
            return false
          }
        })
    },
    clear () {
      this.payload = {
        name: null,
        cpf: null,
        email: null,
        telefoneCelular: null,
        username: null,
        password: null
      }
      this.repeteSenha = null
    },
    salvar () {
      if (!this.user) {
        window.localStorage.setItem('cartaoCompra', JSON.stringify(this.payload))
        eventBus.$emit('openModal', 'login')
        return false
      }

      if (this.user) {
        this.payload.idUser = this.user.id
      }
      this.$store.dispatch('saveCartao', this.payload)
        .then((cartao) => {
          this.$router.push({name: 'CheckoutSinSaude', query: {id: cartao._id, k: this.payload.plano.idPlanoZoop}})
        }).catch((err) => {
          console.log(err)
          let cartaoCache = JSON.parse(window.localStorage.getItem('cartaoCompra'))
          this.payload = cartaoCache
          window.localStorage.removeItem('cartaoCompra')
          this.$router.push({name: 'FormSinSaude'})
        })
    },
    buscaCEP () {
      if (this.payload.cep) {
        this.payload.cep = this.payload.cep.replace(/[-]/g, '')
        if (this.payload.cep.length === 8) {
          http.get(`https://viacep.com.br/ws/${this.payload.cep}/json/`)
            .then((result) => {
              let endereco = result.data
              this.payload.cidade = endereco.localidade
              this.payload.bairro = endereco.bairro
              this.payload.endereco = endereco.logradouro
              this.payload.ufEndereco = endereco.uf
              this.payload.complemento = endereco.complemento
            })
        }
      }
    },
    addDependente () {
      if (this.payload.dependentes.length < this.sizeDependentes) {
        this.payload.dependentes.push({})
      }
    },
    irParaPagamento () {
      let cartaoCache = JSON.parse(window.localStorage.getItem('cartaoCompra'))
      if (this.$store.getters.user) {
        cartaoCache.idUser = this.$store.getters.user.id
      }
      this.$store.dispatch('saveCartao', cartaoCache)
        .then((pedidoCartao) => {
          window.localStorage.removeItem('compraCartao')
          this.$router.push({name: 'CheckoutSinSaude', query: {id: pedidoCartao._id, k: pedidoCartao.plano.idPlanoZoop}})
        }).catch(() => {
          let cartaoCache = JSON.parse(window.localStorage.getItem('cartaoCompra'))
          this.payload = cartaoCache
          window.localStorage.removeItem('cartaoCompra')
          this.$router.push({name: 'FormSinSaude'})
        })
    },
    scrollMeTo (refName) {
      var element = this.$refs[refName]
      var top = element.offsetTop

      window.scrollTo(0, top)
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/pages/FormSinSaude.vue